module.exports = __webpack_public_path__ + "static/img/hb_18-min.be96745.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_18-min.png
// module id = sb/N
// module chunks = 1